import { type ReactNode } from 'react';

import { CloseOutlineIc } from '@dsch/dd-icons';

import { Text } from '../../Text/Text';

import { type TextProps } from '../../Text/Text.typed';

import * as Styled from './ModalHeader.styled';

type ModalHeaderProps = {
  text: ReactNode;
  onRequestClose: () => void;
  modalName: string;
  displayCloseButton?: boolean;
} & TextProps;

const ModalHeader = (props: ModalHeaderProps) => {
  const {
    text,
    displayCloseButton = true,
    onRequestClose,
    modalName,
    className,
    ...rest
  } = props;

  return (
    <Styled.Header className={className}>
      <Text {...rest}>{text}</Text>
      {displayCloseButton && (
        <Styled.CloseButton
          onClick={onRequestClose}
          ofType="GHOST"
          aria-label={`${modalName} close button`}
        >
          <CloseOutlineIc height={16} width={16} />
        </Styled.CloseButton>
      )}
    </Styled.Header>
  );
};

export { ModalHeader };
